import { Client, ClientIndentity, Invoice, ScreenSize } from './../../../models';

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { GenericService } from 'src/app/generic.service';
import { XType } from 'src/app/models';

@Component({
  selector: 'app-id-verify-dialog',
  templateUrl: './id-verify-dialog.component.html',
  styles: [
  ]
})
export class IdVerifyDialogComponent implements OnInit {
 title: string;
 identity = new ClientIndentity();
 photoList: XType[];
 nonPhotoList: XType[];
 id:number;
 client = new Client();
 invoice = new Invoice();
 type: string = '';
  typeId: number = 0;
  isTypeSelected = false;
  size = new ScreenSize();

  constructor(public dialogRef: MatDialogRef<IdVerifyDialogComponent>, @Inject(MAT_DIALOG_DATA) public ddata: any, private service: GenericService) {
    this.title = ddata.title;
    this.id = ddata.id;
    this.client = ddata.client;
    this.invoice = ddata.invoice;
    this.size = this.service.size;
  }


  ngOnInit(): void {

    this.service.getData('Identity/GetClientIdentityId/' + this.id).then(response => {
      this.identity = response.dto;
      if(this.identity.isLicence === true)
      {
        this.preSelectIdType(); 
      }
     
    });

    this.service.getData('Generic/GetXTypeList/' + 'XNonPhotoIdType').then(response => {
      this.nonPhotoList = response;
    });

    this.service.getData('Generic/GetXTypeList/' + 'XPhotoIdType').then(response => {
      this.photoList = response;
    });
    
  }

  close() {
    this.dialogRef.close(null);
  }

  preSelectIdType() {
    this.type = 'Driver Licence';
    this.typeId = 1;
    this.isTypeSelected = true;
  }

  idTypeChange(ev) {
    this.type = ev.value.name;
    this.typeId = Number(ev.value.code);
    this.isTypeSelected = true;
    
  }

  formSubmitted(entity) {
    this.dialogRef.close(entity);
  }


}
